import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { UpcomingEvent } from './UpcomingEvent';
import { LeagueScores } from './LeagueScores';
import { FiveStandResults } from './FiveStandResults';
import { QuickLinks } from './QuickLinks';
export function SportingClaysScoresPage() {
  return <PageLayout data-id="element-3366">
      <HeaderBanner data-id="element-3367" />
      <UpcomingEvent data-id="element-3368" />
      <LeagueScores data-id="element-3369" />
      <FiveStandResults data-id="element-3370" />
      <QuickLinks data-id="element-3371" />
    </PageLayout>;
}